import {ObjectFactory} from "@commons/types";
import {merge} from "lodash";

// Struttura per la raccolta degli identificativi in caricamento, utile per evitare che vengano caricate più volte le stesse tabelle
export interface TabelleInCaricamento {
    qualificaEcc: number[],
    quantificaEcc: number[],
    turniAlternativi: number[],
    tabelleGiustificazioneAuto: number[],
    flex: number[],
    tolleranze: number[],
    fasce: number[],
    calendari: number[],
}

export class TabelleInCaricamento {

    static factory: ObjectFactory<TabelleInCaricamento> = (json?) => {
        return merge<TabelleInCaricamento, Partial<TabelleInCaricamento> | undefined>({
            qualificaEcc: [],
            quantificaEcc: [],
            turniAlternativi: [],
            tabelleGiustificazioneAuto: [],
            flex: [],
            tolleranze: [],
            fasce: [],
            calendari: [],
        }, json);
    }

    /**
     * La funzione controlla se la tabella è gia presente, in tal caso restituisce false; in caso contrario aggiunge la tabella in struttura e restituisce true per avvalere il relativo caricamento.
     * @param tabella istanza della struttura
     * @param item specifica della tabella (keyof TabelleInCaricamento)
     * @param id id della tabella in caricamento
     */
    static addTabella(tabella: TabelleInCaricamento, item: keyof TabelleInCaricamento, id: number) {
        if (tabella[item].indexOf(id) >= 0)
            return false;
        else {
            tabella[item].push(id);
            return true;
        }
    }
}